
        require('./index.scss');
        'use strict';

var $ = window.$;

var _module = {
    init: function init() {
        var that = this;
        var name = $('.tab-head').find('ul').attr('data-name');
        var list = $('.tab-head').find('li a');
        var category = $('.tab-body').find('div');
        for (var i = 0; i < list.length; i++) {
            if (list[i].innerText === name) {
                list.eq(i).addClass('active');
                category.eq(that.active()).addClass('active');
            }
        }
        for (var _i = 0; _i < category.length; _i++) {
            if (!category.eq(_i).hasClass('active')) {
                category.eq(_i).css('display', 'none');
                list.eq(_i).next().css('display', 'none');
            } else {
                category.eq(_i).css('display', 'block');
                list.eq(_i).next().css('display', 'block');
            }
        }
        list.hover(function (e) {
            list.removeClass('active');
            category.removeClass('active');
            $(e.target).addClass('active');
            category.eq(that.active()).addClass('active');
            for (var _i2 = 0; _i2 < category.length; _i2++) {
                if (!category.eq(_i2).hasClass('active')) {
                    category.eq(_i2).css('display', 'none');
                } else {
                    category.eq(_i2).css('display', 'block');
                }
                if (list.eq(_i2).hasClass('active')) {
                    list.eq(_i2).next().css('display', 'block');
                } else {
                    list.eq(_i2).next().css('display', 'none');
                }
            }
        }, function () {});
    },
    active: function active() {
        var list = $('.tab-head').find('li a');
        for (var i = 0; i < list.length; i++) {
            if (list.eq(i).hasClass('active')) return i;
        }
        return 0;
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-list/tab/index.js